import React from 'react'
import Badge from './ui/Badge'
import ConvictionBar from './ui/ConvictionBar'
import { formatPrice } from '../utils/format'
import { actionMeta } from '../utils/tone'

export default function InvestorCard({ member, opinion }) {
  const meta = actionMeta(opinion.action)

  return (
    <div
      className="onds-card p-5 flex flex-col gap-4 border-t-2"
      style={{ borderTopColor: member.accent }}
    >
      <div className="flex items-start gap-3">
        <div
          className="w-11 h-11 rounded-xl flex items-center justify-center text-sm font-bold shrink-0"
          style={{ backgroundColor: `${member.accent}22`, color: member.accent, border: `1px solid ${member.accent}55` }}
        >
          {member.initials}
        </div>
        <div className="min-w-0">
          <h3 className="font-bold leading-tight truncate">{member.name}</h3>
          <p className="text-[11px] text-[var(--onds-text-dim)]">{member.era} · {member.style}</p>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <Badge tone={meta.tone} filled>{meta.label}</Badge>
        {opinion.targetPrice != null && (
          <div className="text-right">
            <div className="text-[10px] uppercase tracking-wider text-[var(--onds-text-dim)]">Target</div>
            <div className="text-sm font-bold tabular-nums">{formatPrice(opinion.targetPrice)}</div>
          </div>
        )}
      </div>

      <ConvictionBar value={opinion.conviction} />

      {opinion.thesis?.trim() ? (
        <p className="text-sm text-[var(--onds-text-dim)] leading-relaxed">{opinion.thesis}</p>
      ) : (
        <p className="text-sm text-[var(--onds-text-dim)] italic leading-relaxed">Position not recorded this run — re-run analysis if this persists.</p>
      )}

      <div className="mt-auto">
        <div className="text-[10px] uppercase tracking-wider text-[var(--onds-text-dim)] mb-1">{opinion.horizon ? `Key Risks · ${opinion.horizon}` : 'Key Risks'}</div>
        <ul className="flex flex-col gap-1">
          {(opinion.risks ?? []).map((risk, i) => (
            <li key={i} className="text-xs flex gap-2">
              <span style={{ color: 'var(--onds-bear)' }}>▪</span>
              <span className="text-[var(--onds-text-dim)]">{risk}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
